import styled from "styled-components";

const OrderDetailsWrapper = styled.div`
    .expand-collapse-class{
        display: flex;
        h4{
            background: #005586;
            padding: 0px;
            width: 17px;
            border-radius: 50%;
            height: 16px;
            margin: 3px 0px 0px 0px;
            cursor: pointer;
            i {
                border: solid #ffff;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 2px;
                margin: 0px 0px 13px 6px;
                transform: rotate(-135deg);
                -webkit-transform: rotate(-135deg);
            }
        }  
        h5{
            background: #005586;
            padding: 0px;
            width: 16px;
            border-radius: 50%;
            height: 16px;
            margin: 3px 0px 0px 0px;
            cursor: pointer;
            i {
                border: solid #ffff;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 2px;
                margin: 0px 0px 13px 5px;
                transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
            }
        }
    }
    .remark{
        word-wrap: break-word;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        max-width: 125px;
    }
    .order-details-wrapper{
        td{
            border: none;
        }
        h6{
            font-size: 13px;
            font-weight: bold;
        }
        p{
            font-size: 14px;
        }
        .print-tag-style{
            border: 1px solid #E5E5E5;
            padding: 3px 10px 4px;
            white-space:nowrap;
            border-radius: 3px;
            background: #fff;
        }
    }
`;

const NotesModalWrapper = styled.div`
    .modal-body{
      padding: 0px !important;
    }
    .modal-content{
      border-radius: 0px !important;
    }
    .modal-header-style{
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 0px;
      h6{
        margin: 12px 12px 12px 25px;
        font-weight: bold;
        text-align: center;
        flex-grow: 1; 
      }
      img{
        margin: 12px 25px 12px 12px;
        height: 20px;
        width: 20px;
        cursor: pointer;
      }
    }
    .modal-content-style{
      display: flex;
      padding: 15px 25px 15px 25px;
      justify-content: space-between;
      input{
        min-width: 404px;
        font-size: 16px;
      }
      input::-webkit-input-placeholder {
        color: #9c9c9c !important;
        font-size: 14px !important;
      }
      .invite-email-style{
        padding: 5px 5px 5px 15px;
        border: 1px solid #DADADF;
        border-radius: 4px;
        width: 75%;
        font-size: 14px;
      }
      .invite-button-disabled{
        margin-left: 10px;
        width: 100px;
        height: 40px;
        background: #F2F2F2;
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        font-size: 14px;
      }
      .invite-button{
        margin-left: 10px;
        width: 100px;
        height: 40px;
        background: linear-gradient(180deg, #55C416 0%, #367910 100%);
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        color: #fff;
        cursor: pointer;
      }
      .app-input-text{
        margin-bottom: 15px !important;
      }
    }
    .specfiles-wrapper{
      .check-disabled{
        .radio-checkmark{
          background: grey;
          border: none;
        }
      }
    }
`;

const DateWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  input {
    border: solid 1px transparent !important;
    margin: 2px 0;
    font-size: 16px;
    padding: 8px 8px 8px 10px;
    border-radius: 5px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    min-width: 112px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #656565;
    }
    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #656565;
    }

    ::placeholder {
      color: #656565;
    }
  }
  .custom-date-piker{
    margin-top: 2px;
    max-width: 200px !important;
  }
  label {
    padding: 9px;
    margin: 2px 0 0;
    font-size: 16px;
  }
  .file-input-wrapper .MuiFormControl-root .MuiInput-root{
    padding: 0 14px;
  }
`;
export {
    OrderDetailsWrapper,
    NotesModalWrapper,
    DateWrapper
};